@if (!inView()) {
    <div class="st-story-item-content-container"></div>
}
@if (inView()) {
    <div
        class="st-story-item-border-left"
        st-left-border
        [data]="data()"></div>
}
@switch (cardViewType()) {
    @case (CardViewTypes.SMALL) {
        <ng-container *ngTemplateOutlet="smallCard" />
    }
    @case (CardViewTypes.MEDIUM) {
        <ng-container *ngTemplateOutlet="mediumCard" />
    }
    @default {
        <ng-container *ngTemplateOutlet="largeCard" />
    }
}
<ng-template #largeCard>
    @if (inView()) {
        <div
            class="st-story-item-content-container"
            [class.st-story-item-content-container__mouse-entered]="mouseEntered()"
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()">
            <div class="st-story-item-content-container__static">
                <div class="st-story-item-content-container-main">
                    <div class="st-story-item-content-container-main-top-row">
                        <st-story-output-type
                            showLabel
                            showIcon="false"
                            [record]="data()"
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria[PSTFieldNames?.PSTStoryOutputType]"
                            [value]="data()?.PSTStoryOutputType"
                            (changed)="updateStory($event, PSTFieldNames.PSTStoryOutputType)" />
                        @if (primarySubstoriesVisible() || isSubStory()) {
                            <span class="st-story-item-content-container-main__story-level-type-label">
                                {{ isSubStory() ? languageSettings().PSTWebSecondaryStoryLabel : languageSettings().PSTWebPrimaryStoryLabel }}
                            </span>
                        }
                        <span
                            class="st-story-item-content-container-main__rundown-name"
                            [class.st-story-item-content-container-main__rundown-not-assigned]="!hasRundown()">
                            {{ rundownLabel() }}
                        </span>
                        @if (isArchived()) {
                            <span class="st-story-item-content-container-main__archived">{{ archivedLabel() }}</span>
                        }
                        @if (!data()?.isNewRecord) {
                            <span class="st-story-item-content-container-main__time-updated">{{ timeUpdatedLabel() }}</span>
                            <span class="st-story-item-content-container-main__updated-by">{{ updatedBy() }}</span>
                        }
                    </div>
                    <st-text-area-overlay
                        required
                        class="st-story-item-content-container-main__slug"
                        minRows="1"
                        maxHeight="1rem"
                        maxLength="50"
                        disableNewLine
                        panelClass="st-story-item-content-container-main__slug"
                        [value]="data()?.Title"
                        [disabled]="cardDisabled()"
                        [textToHighlight]="searchString$ | ngrxPush"
                        [placeholder]="languageSettings().PSTWebSlugPlaceholder"
                        (changed)="updateStory($event, PSTFieldNames.Title)" />
                    <st-text-area-overlay
                        required
                        class="st-story-item-content-container-main__summary"
                        maxRows="3"
                        minRows="3"
                        minHeight="3rem"
                        panelClass="st-story-item-content-container-main__summary"
                        disabled
                        [value]="storyText()"
                        [textToHighlight]="searchString$ | ngrxPush"
                        [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description]?.DefaultCaption" />
                    <st-tags-autocomplete
                        [value]="data()?.Tags"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTTags]"
                        [maxItemsToShow]="maxTagsToShow()"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTTags]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTTags]?.DefaultCaption"
                        (changed)="updateStory($event, PSTFieldNames.PSTTags)" />
                </div>
                <div class="st-story-item-content-container-meta">
                    <div class="st-story-item-content-container-meta__row">
                        @if (globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME) {
                            <st-date-time-picker
                                class="st-story-item-content-container-meta__date-picker"
                                asCustomField
                                [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                                [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                                [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                                (timezoneChange)="timezoneChanged(PSTFieldNames?.TargetPublicationDate, $event)"
                                (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
                        } @else {
                            <st-date-picker
                                class="st-story-item-content-container-meta__date-picker"
                                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                                [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                                [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                                [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                                (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
                        }
                        <st-status
                            class="st-story-item-content-container-meta__status"
                            [value]="data()?.PSTStoryStatus"
                            [fieldName]="PSTFieldNames.PSTStoryStatus"
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryStatus]"
                            [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required"
                            [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                            [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                            [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTStoryStatus)"
                            [data]="data()"
                            [itemType]="data()?.PSTStoryStatus?.id"
                            [statusFieldName]="PSTFieldNames.PSTStoryStatus"
                            [addEmptyOption]="!globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required"
                            (changed)="updateStory($event, PSTFieldNames.PSTStoryStatus)" />
                        <div class="st-story-item-content-container-actions">
                            @if (approvedVisible() && !cardDisabled()) {
                                <button
                                    class="st-story-item-content-container-actions__approve"
                                    mat-icon-button
                                    [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.Approved]"
                                    [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.Approved]?.DefaultCaption"
                                    [class.st-story-item-content-container-actions__approve--active]="data()?.Approved"
                                    (click)="updateStory(!data()?.Approved, PSTFieldNames.Approved)">
                                    <mat-icon>done</mat-icon>
                                </button>
                            }
                            @if (!isWastebin()) {
                                <button
                                    class="st-story-item-content-container-actions__fullscreen"
                                    mat-icon-button
                                    [matTooltip]="displayOpenActionButtonHoverTitle()"
                                    [disabled]="isPreview()"
                                    (click)="itemClicked.emit()">
                                    <mat-icon>fullscreen</mat-icon>
                                </button>
                            }
                            @if (isWastebin()) {
                                <button
                                    mat-icon-button
                                    [matTooltip]="i18n.PSTWebRestoreContentTitle"
                                    (click)="restoreContent.emit()">
                                    <mat-icon>history</mat-icon>
                                </button>
                            }
                            <st-external-actions-overlay
                                [inSidecarOpened]="inSidecarOpenedMode()"
                                [inFullScreen]="inFullscreenMode()"
                                [data]="data()"
                                [disabled]="cardDisabled()"
                                [editable]="!cardDisabled()"
                                [objectOpen]="itemClicked" />
                        </div>
                    </div>
                    <div class="st-story-item-content-container-meta__row">
                        <st-desk
                            class="st-story-item-content-container-assigns__desk"
                            [value]="data()?.PSTGroup"
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTDesk]"
                            [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.Required"
                            [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                            [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                            [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                            [data]="data()"
                            [fieldName]="PSTFieldNames?.PSTDesk"
                            (changed)="updateStory($event, PSTFieldNames.PSTDesk)" />
                        <st-staff-id-list
                            class="st-story-item-content-container-assigns__owners"
                            [value]="data()?.PSTStoryOwner"
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryOwner]"
                            [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.Required"
                            [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.DefaultCaption"
                            (changed)="updateStory($event, PSTFieldNames.PSTStoryOwner)" />
                    </div>
                    <div class="st-story-item-content-container-meta__row">
                        @if (primarySubstoriesVisible() || isSubStory()) {
                            @if (isSubStory()) {
                                <st-story-icon-list
                                    addIcon="link"
                                    maxItemsToShow="1"
                                    [parentLabel]="parentStory()?.Title"
                                    [value]="parentStoryList()"
                                    [cardDisabled]="cardDisabled()"
                                    (itemClicked)="openRelatedStory($event)" />
                            } @else {
                                <st-story-icon-list
                                    maxItemsToShow="4"
                                    [value]="subStories()"
                                    [templates]="storyTemplates()"
                                    [cardDisabled]="cardDisabled()"
                                    [topicEditable]="!cardDisabled()"
                                    [parentRecord]="data()"
                                    [addLabelKey]="addSubStoryLabelKey"
                                    (itemClicked)="openRelatedStory($event)"
                                    (extraItemsClicked)="openSubStoriesInSidecar()"
                                    (createStoryEvent)="createSubStory($event)" />
                            }
                        }
                        <st-topic-button
                            class="st-story-item-content-container__topic-button"
                            [class.st-story-item-content-container__topic-button--readonly]="!inFullscreenMode()"
                            [value]="topicRecord()?.Title"
                            [label]="addToTopicLabel()"
                            [inFullScreenMode]="inFullscreenMode()"
                            (topicOpenEmitter)="onTopicOpenHandler(topicRecord())" />
                    </div>
                </div>
            </div>
        </div>
    }
</ng-template>

<ng-template #mediumCard>
    @if (inView()) {
        <div
            class="st-story-item-content-container__medium"
            [class.st-story-item-content-container__mouse-entered]="mouseEntered()"
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()">
            <div class="st-story-item-content-container__medium__left-column">
                <div class="st-story-item-content-container__medium__top-row">
                    <st-story-output-type
                        showLabel
                        showIcon="false"
                        [record]="data()"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[PSTFieldNames?.PSTStoryOutputType]"
                        [value]="data()?.PSTStoryOutputType"
                        (changed)="updateStory($event, PSTFieldNames.PSTStoryOutputType)" />
                    @if (primarySubstoriesVisible() || isSubStory()) {
                        <span class="st-story-item-content-container-main__story-level-type-label">
                            {{ isSubStory() ? languageSettings().PSTWebSecondaryStoryLabel : languageSettings().PSTWebPrimaryStoryLabel }}
                        </span>
                    }
                    <span
                        class="st-story-item-content-container-main__rundown-name"
                        [class.st-story-item-content-container-main__rundown-not-assigned]="!hasRundown()">
                        {{ rundownLabel() }}
                    </span>
                    @if (isArchived()) {
                        <span class="st-story-item-content-container-main__archived">{{ archivedLabel() }}</span>
                    }
                </div>
                <div class="st-story-item-content-container__medium__main-content">
                    <st-text-area-overlay
                        required
                        class="st-story-item-content-container-main__slug"
                        minRows="1"
                        maxHeight="1rem"
                        maxLength="50"
                        maxRows="1"
                        disableNewLine
                        panelClass="st-story-item-content-container-main__slug"
                        [value]="data()?.Title"
                        [disabled]="cardDisabled()"
                        [textToHighlight]="searchString$ | ngrxPush"
                        [placeholder]="languageSettings().PSTWebSlugPlaceholder"
                        (changed)="updateStory($event, PSTFieldNames.Title)" />
                    <st-text-area-overlay
                        class="st-story-item-content-container-main__summary"
                        maxRows="2"
                        minHeight="2rem"
                        panelClass="st-story-item-content-container-main__summary"
                        disabled
                        [value]="storyText()"
                        [textToHighlight]="searchString$ | ngrxPush"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.Description]?.Required"
                        [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description]?.DefaultCaption"
                        (changed)="updateStory($event, PSTFieldNames.Description)" />
                </div>
                <div class="st-story-item-content-container__medium__metadata">
                    <st-desk
                        class="st-topic-item-content-container-assigns__desk"
                        maxItemsToShow="0"
                        [value]="data()?.PSTGroup"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTDesk]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                        [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTDesk]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                        [data]="data()"
                        [fieldName]="PSTFieldNames?.PSTDesk"
                        (changed)="updateStory($event, PSTFieldNames.PSTDesk)" />
                    <st-staff-id-list
                        class="st-story-item-content-container-assigns__owners"
                        [value]="data()?.PSTStoryOwner"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryOwner]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryOwner]?.DefaultCaption"
                        [maxItemsToShow]="0"
                        (changed)="updateStory($event, PSTFieldNames.PSTStoryOwner)" />
                    @if (primarySubstoriesVisible() || isSubStory()) {
                        @if (isSubStory()) {
                            <st-story-icon-list
                                addIcon="link"
                                class="st-story-item-content-container-assigns__substories"
                                maxItemsToShow="1"
                                [cardViewType]="cardViewType()"
                                [value]="parentStoryList()"
                                [cardDisabled]="cardDisabled()"
                                (itemClicked)="openRelatedStory($event)" />
                        } @else {
                            <st-story-icon-list
                                class="st-story-item-content-container-assigns__substories"
                                maxItemsToShow="0"
                                [cardViewType]="cardViewType()"
                                [value]="subStories()"
                                [templates]="storyTemplates()"
                                [cardDisabled]="cardDisabled()"
                                [topicEditable]="!cardDisabled()"
                                [parentRecord]="data()"
                                [addLabelKey]="addSubStoryLabelKey"
                                (itemClicked)="openRelatedStory($event)"
                                (extraItemsClicked)="openSubStoriesInSidecar()"
                                (createStoryEvent)="createSubStory($event)" />
                        }
                    }
                    <st-topic-button
                        class="st-story-item-content-container__topic-button"
                        [class.st-story-item-content-container__topic-button--readonly]="!inFullscreenMode()"
                        [value]="topicRecord()?.Title"
                        [label]="addToTopicLabel()"
                        [inFullScreenMode]="inFullscreenMode()"
                        (topicOpenEmitter)="onTopicOpenHandler(topicRecord())" />
                </div>
            </div>
            <div class="st-story-item-content-container__medium__right-column">
                <span
                    class="st-story-item-content-container__medium__time-updated-by"
                    [title]="timeUpdatedByLabel()">
                    @if (!data()?.isNewRecord) {
                        {{ timeUpdatedByLabel() }}
                    }
                </span>
                @if (globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Validation?.toUpperCase() === FieldDefValidations.TIME) {
                    <st-date-time-picker
                        class="st-story-item-content-container-meta__date-picker"
                        asCustomField
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                        [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                        (timezoneChange)="timezoneChanged(PSTFieldNames?.TargetPublicationDate, $event)"
                        (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
                } @else {
                    <st-date-picker
                        class="st-story-item-content-container-meta__date-picker"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.Required"
                        [label]="globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.TargetPublicationDate]"
                        [value]="data()?.[PSTFieldNames.TargetPublicationDate]"
                        (changed)="updateStory($event, PSTFieldNames.TargetPublicationDate)" />
                }
                <div class="st-story-item-content-container__medium__right-column__status">
                    <st-status
                        class="st-story-item-content-container-meta__status"
                        [value]="data()?.PSTStoryStatus"
                        [fieldName]="PSTFieldNames.PSTStoryStatus"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.PSTStoryStatus]"
                        [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required"
                        [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                        [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.DefaultCaption"
                        [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTStoryStatus)"
                        [data]="data()"
                        [itemType]="data()?.PSTStoryStatus?.id"
                        [statusFieldName]="PSTFieldNames.PSTStoryStatus"
                        [addEmptyOption]="!globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required"
                        (changed)="updateStory($event, PSTFieldNames.PSTStoryStatus)" />
                    @if (approvedVisible() && !cardDisabled()) {
                        <button
                            class="st-story-item-content-container-actions__approve"
                            mat-icon-button
                            [disabled]="cardDisabled() || data()?.readOnlyCriteria?.[PSTFieldNames?.Approved]"
                            [matTooltip]="globalTablesService.FieldDefsDict[PSTFieldNames?.Approved]?.DefaultCaption"
                            [class.st-story-item-content-container-actions__approve--active]="data()?.Approved"
                            (click)="updateStory(!data()?.Approved, PSTFieldNames.Approved)">
                            <mat-icon>done</mat-icon>
                        </button>
                    }
                    @if (!isWastebin()) {
                        <button
                            class="st-story-item-content-container__fullscreen"
                            mat-icon-button
                            [matTooltip]="displayOpenActionButtonHoverTitle()"
                            [disabled]="isPreview()"
                            (click)="itemClicked.emit()">
                            <mat-icon>fullscreen</mat-icon>
                        </button>
                    }
                    @if (isWastebin()) {
                        <button
                            mat-icon-button
                            [matTooltip]="i18n.PSTWebRestoreContentTitle"
                            (click)="restoreContent.emit()">
                            <mat-icon>history</mat-icon>
                        </button>
                    }
                    <st-external-actions-overlay
                        class="st-story-item-content-container-actions__external"
                        [inSidecarOpened]="inSidecarOpenedMode()"
                        [inFullScreen]="inFullscreenMode()"
                        [data]="data()"
                        [disabled]="cardDisabled()"
                        [editable]="!cardDisabled()"
                        [objectOpen]="itemClicked" />
                </div>
            </div>
        </div>
    }
</ng-template>

<ng-template #smallCard>
    @if (inView()) {
        <div class="st-story-item-content-container__mobile">
            <div class="st-story-item-content-container__mobile__container">
                <div class="st-story-item-content-container__mobile__top-row">
                    <st-story-output-type
                        showLabel
                        showIcon="false"
                        [record]="data()"
                        [disabled]="cardDisabled() || data()?.readOnlyCriteria[PSTFieldNames?.PSTStoryOutputType]"
                        [value]="data()?.PSTStoryOutputType"
                        (changed)="updateStory($event, PSTFieldNames.PSTStoryOutputType)" />
                    <div
                        class="st-story-item-content-container__mobile__status"
                        [class.st-story-item-content-container__mobile__status-required]="
                            enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.PSTStoryStatus]?.Required && !data()?.PSTStoryStatus
                        ">
                        {{ data()?.PSTStoryStatus?.title || globalTablesService.FieldDefsDict[PSTFieldNames.PSTStoryStatus]?.DefaultCaption }}
                    </div>
                    @if (isArchived()) {
                        <span class="st-story-item-content-container-main__archived">{{ archivedLabel() }}</span>
                    }
                </div>
                <div
                    class="st-story-item-content-container__mobile__slug"
                    [class.st-story-item-content-container__mobile__slug-required]="
                        enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[PSTFieldNames?.Title]?.Required && !data()?.Title
                    ">
                    {{ data()?.Title || globalTablesService.FieldDefsDict[PSTFieldNames.Title]?.DefaultCaption }}
                </div>
                <div class="st-story-item-content-container__mobile__assignments">
                    <div class="st-story-item-content-container__mobile--desk">
                        <mat-icon class="st-story-item-content-container__mobile--desk__icon">business</mat-icon>
                        <span class="st-story-item-content-container__mobile--desk__text">{{ desks() }}</span>
                    </div>
                    <div class="st-story-item-content-container__mobile--owner">
                        <mat-icon class="st-story-item-content-container__mobile--owner__icon">people</mat-icon>
                        <span class="st-story-item-content-container__mobile--owner__text">{{ owners() }}</span>
                    </div>
                    <div class="st-story-item-content-container__mobile--rundown">
                        <mat-icon class="st-story-item-content-container__mobile--rundown__icon">{{ topicOrRundownIcon() }}</mat-icon>
                        <span class="st-story-item-content-container__mobile--rundown__text">{{ topicOrRundownLabel() }}</span>
                    </div>
                </div>
            </div>
        </div>
    }
</ng-template>
